import { useCallback, useEffect, useRef, useState } from 'react';

export default function useCopyFeedback(delay = 1400) {
  const [copiedValue, setCopiedValue] = useState('');
  const timer = useRef(null);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const copyValue = useCallback(async value => {
    if (!value) return;
    await navigator.clipboard.writeText(String(value));
    setCopiedValue(String(value));
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setCopiedValue(''), delay);
  }, [delay]);

  return { copiedValue, copyValue };
}
